import React from "react";
import "./style.css";

const Loader = ({ message = "Carregando dados..." }) => {
  return (
    <div
      className="loader-overlay"
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div className="loader-spinner" />
      <p className="loader-text">{message}</p>
    </div>
  );
};

export default Loader;
